"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHTMLInputCursorState = void 0;
var _react = require("react");
/* Copied from platejs source */

var useHTMLInputCursorState = function useHTMLInputCursorState(ref) {
  var _ref = (0, _react.useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    atStart = _ref2[0],
    setAtStart = _ref2[1];
  var _ref3 = (0, _react.useState)(false),
    _ref4 = _slicedToArray(_ref3, 2),
    atEnd = _ref4[0],
    setAtEnd = _ref4[1];
  var recomputeCursorState = (0, _react.useCallback)(function () {
    // Wait for events to finish processing
    setTimeout(function () {
      if (!ref.current) return;
      var _ref$current = ref.current,
        selectionEnd = _ref$current.selectionEnd,
        selectionStart = _ref$current.selectionStart,
        value = _ref$current.value;
      setAtStart(selectionStart === 0);
      setAtEnd(selectionEnd === value.length);
    });
  }, [ref]);
  (0, _react.useEffect)(function () {
    recomputeCursorState();
    var input = ref.current;
    if (!input) return;
    input.addEventListener('input', recomputeCursorState);
    input.addEventListener('selectionchange', recomputeCursorState);

    /**
     * Compat: selectionchange is not supported for <input> except in Firefox,
     * so we add keydown, pointerdown and pointerup as fallbacks (2024-06-14).
     */
    input.addEventListener('keydown', recomputeCursorState);
    input.addEventListener('pointerdown', recomputeCursorState);
    input.addEventListener('pointerup', recomputeCursorState);
    return function () {
      input.removeEventListener('input', recomputeCursorState);
      input.removeEventListener('selectionchange', recomputeCursorState);
      input.removeEventListener('keydown', recomputeCursorState);
      input.removeEventListener('pointerdown', recomputeCursorState);
      input.removeEventListener('pointerup', recomputeCursorState);
    };
  }, [recomputeCursorState, ref]);
  return (0, _react.useMemo)(function () {
    return {
      atEnd: atEnd,
      atStart: atStart
    };
  }, [atStart, atEnd]);
};
exports.useHTMLInputCursorState = useHTMLInputCursorState;